<div class="col-md-12">
    <h3 class="">Set Compliance Approved Date</h3>  
    <hr style="margin: 0;border: lightgray solid 0.5px; ">
    <br />
    <div class="panel panel-primary"  >
      <div class="panel-heading">Enter Compliance Approved Date</div>
      <div class="panel-body">
          <div class="form">
                  <form name="form" (ngSubmit)="f.form.valid && OnSubmit()" #f="ngForm"  novalidate>
              <div class="form-group row">
                <div class="col-sm-3">
                  <input class="form-control" placeholder="dd-mm-yyyy"
                  name="dpAppr" id="dpAppr" [(ngModel)]="ApprDt" ngbDatepicker #dt="ngbDatepicker" #dpAppr="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpAppr.invalid }" required> 
                  <div *ngIf="f.submitted && dpAppr.invalid" class="invalid-feedback invalid-display">
                    <div *ngIf="dpAppr.errors?.['required']">*Approved date is required</div>
                  </div>
                </div>
                 <div class="col-sm-1" style="padding-left: 0px;">
                    <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button"></button>
                 </div>
                  <div>
                      <button class="btn btn-primary ">Set Date</button>  
                  </div>
             
              </div>
          </form>
          </div>
    </div>
  </div>